import React, { useState } from 'react';
import Utils from '../util/Utils.jsx';
import { Button, FormControl, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import dayjs from '../util/date.js';

import { useStateValue } from '../context/state.jsx';
import { openAlert } from '../context/alert.js';
import { setMustChangePassword } from '../context/mustChangePassword.js';

const AccountSetup = () => {
	const [newEmail, setNewEmail] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [savingEmail, setSavingEmail] = useState(false);
	const [savingPassword, setSavingPassword] = useState(false);
	const [inlineMessage, setInlineMessage] = useState(null);

	const [{ emailAddress, createDate, mustChangePassword }, dispatch] = useStateValue();

	const showInline = (type, text) => {
		setInlineMessage({ type, text });
	};

	const updateEmail = () => {
		if (!newEmail.trim()) return;
		setSavingEmail(true);
		setInlineMessage(null);
		const postData = { emailAddress: newEmail };
		Utils.ajax('updateUser', postData, dispatch, result => {
			setSavingEmail(false);
			if (result.success) {
				showInline('success', `Verification email sent to ${newEmail}. Click the link in that email to finish.`);
				dispatch(openAlert('Email Sent', `An email has been sent to ${newEmail} with a verify link. Please verify your change by clicking on the link in it.`));
				setNewEmail('');
			}
		});
	};

	const updatePassword = () => {
		if (!newPassword) return;
		setSavingPassword(true);
		setInlineMessage(null);
		const postData = { password: newPassword };
		Utils.ajax('updateUser', postData, dispatch, result => {
			setSavingPassword(false);
			if (result.success) {
				dispatch(setMustChangePassword(false));
				showInline('success', 'Your password has been updated successfully.');
				dispatch(openAlert('Password Updated', 'Your password has been updated successfully.'));
				setNewPassword('');
			}
		});
	};

	return (
		<div className="paddedTabContent setupAccountPane">
			<div className="setupSectionHeader">
				<div>
					<h2>Account settings</h2>
					<p>Update the email and password used to sign in to SiteWalker.</p>
				</div>
			</div>

			{mustChangePassword && (
				<div className="setupInlineAlert setupInlineAlert-warning" role="status">
					Your account still uses a temporary password. Please set a new password below.
				</div>
			)}

			{inlineMessage && (
				<div className={`setupInlineAlert setupInlineAlert-${inlineMessage.type}`} role="status">
					{inlineMessage.text}
				</div>
			)}

			<div className="setupCard">
				<div className="setupCardHeader">
					<h3>Profile</h3>
				</div>
				<div className="setupCardBody">
					<div className="setupFieldGrid">
						<FormGroup controlId="setupCurrentEmail">
							<ControlLabel>Current email</ControlLabel>
							<div className="setupReadonlyValue">{emailAddress || '—'}</div>
						</FormGroup>
						<FormGroup controlId="setupCreated">
							<ControlLabel>Account created</ControlLabel>
							<div className="setupReadonlyValue">
								{createDate ? dayjs(parseInt(createDate * 1000, 10)).format('DD-MMM-YYYY h:mm:ss a') : '—'}
							</div>
						</FormGroup>
					</div>
				</div>
			</div>

			<div className="setupCard">
				<div className="setupCardHeader">
					<h3>Change email</h3>
				</div>
				<div className="setupCardBody">
					<FormGroup controlId="setupNewEmail">
						<ControlLabel>New email address</ControlLabel>
						<FormControl
							type="email"
							className="setupInput"
							value={newEmail}
							placeholder="newemail@address.com"
							onChange={e => setNewEmail(e.target.value)}
						/>
						<HelpBlock>We’ll send a verification link before the change takes effect.</HelpBlock>
					</FormGroup>
					<Button
						bsStyle="primary"
						className="setupPrimaryBtn"
						disabled={!newEmail.trim() || savingEmail}
						onClick={updateEmail}>
						{savingEmail ? 'Sending…' : 'Update email address'}
					</Button>
				</div>
			</div>

			<div className="setupCard">
				<div className="setupCardHeader">
					<h3>Change password</h3>
				</div>
				<div className="setupCardBody">
					<FormGroup controlId="setupNewPassword">
						<ControlLabel>New password</ControlLabel>
						<FormControl
							type="password"
							className="setupInput"
							value={newPassword}
							placeholder="Enter a new password"
							onChange={e => setNewPassword(e.target.value)}
						/>
					</FormGroup>
					<Button
						bsStyle="primary"
						className="setupPrimaryBtn"
						disabled={!newPassword || savingPassword}
						onClick={updatePassword}>
						{savingPassword ? 'Saving…' : 'Update password'}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default AccountSetup;
